
// import React, { useState } from "react";
// import {
//   Box,
//   Tooltip,
//   Typography,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
// import AssignmentIcon from "@mui/icons-material/Assignment";

// // Import the delivery tracker component
// import DeliveryTrackerAdmin from "./DeliveryTrackerAdmin";

// // Import the delivery report component
// import DeliveryReportModal from "./DeliveryReportModal";

// // Import the assigned orders cell component
// import AssignedOrdersCell from "./AssignedOrdersCell";

// const ActionsCell = ({
//   params,
//   handleEdit,
//   setOpenDeleteDriver,
//   setSelectedDriver,
//   setOpenViewDetails,
//   setSelectedDriverForView,
//   // Props for assign orders modal
//   setOpenAssignOrders,
//   setSelectedDriverForAssignOrders,
//   // Props for clear orders modal
//   setOpenClearOrders,
//   setSelectedDriverForClearOrders,
// }) => {
//   console.log("props test", params)
//   const [openTrackDelivery, setOpenTrackDelivery] = useState(false);
//   const [openDeliveryReport, setOpenDeliveryReport] = useState(false);

//   const onEditClick = () => {
//     handleEdit(params.row);
//   };

//   const onDeleteClick = () => {
//     setSelectedDriver(params.row);
//     setOpenDeleteDriver(true);
//   };

//   const onViewDetailsClick = () => {
//     setSelectedDriverForView(params.row);
//     setOpenViewDetails(true);
//   };

//   const onTrackDeliveryClick = () => {
//     setOpenTrackDelivery(true);
//   };

//   const onDeliveryReportClick = () => {
//     setOpenDeliveryReport(true);
//   };

//   const onAssignOrdersClick = () => {
//     setSelectedDriverForAssignOrders(params.row);
//     setOpenAssignOrders(true);
//   };

//   const onClearOrdersClick = () => {
//     setSelectedDriverForClearOrders(params.row);
//     setOpenClearOrders(true);
//   };

//   const handleCloseTrackDelivery = () => {
//     setOpenTrackDelivery(false);
//   };

//   const handleCloseDeliveryReport = () => {
//     setOpenDeliveryReport(false);
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: 1,
//         height: "100%",
//         minHeight: "52px",
//       }}
//     >
//       {/* Edit Button */}
//       {params.row.allow_edit === 1 && (
//         <Box
//           display="flex"
//           alignItems="center"
//           sx={{
//             backgroundColor: "#FAFAFA",
//             borderRadius: "6px",
//             border: "1px solid #E0E0E0",
//             padding: "4px 0",
//             gap: 1,
//           }}
//         >
//           <Tooltip title="Edit">
//             <Box
//               display="flex"
//               alignItems="center"
//               sx={{
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   backgroundColor: "#F0F0F0",
//                 },
//               }}
//               onClick={onEditClick}
//             >
//               <EditIcon fontSize="small" sx={{ color: "#48505E" }} />
//               <Typography
//                 variant="body2"
//                 sx={{
//                   ml: 1,
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   color: "#1976D2",
//                 }}
//               >
//                 Edit
//               </Typography>
//             </Box>
//           </Tooltip>
//         </Box>
//       )}

//       {/* Delete Button - Only show if delete is enabled */}
//       {params.row.driver_deleted_button === 1 && (
//         <>
//           <Box
//             sx={{
//               height: "20px",
//               width: "1px",
//               backgroundColor: "#E0E0E0",
//             }}
//           />
//           <Box
//             display="flex"
//             alignItems="center"
//             sx={{
//               backgroundColor: "#FAFAFA",
//               borderRadius: "6px",
//               border: "1px solid #E0E0E0",
//               padding: "4px 8px",
//               gap: 1,
//             }}
//           >
//             <Tooltip title="Delete">
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 sx={{
//                   cursor: "pointer",
//                   padding: "4px 8px",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     backgroundColor: "#FFEBEE",
//                   },
//                 }}
//                 onClick={onDeleteClick}
//               >
//                 <DeleteForeverIcon fontSize="small" sx={{ color: "#d32f2f" }} />
//                 <Typography
//                   variant="body2"
//                   sx={(theme) => ({
//                     ml: 1,
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: theme.palette.error.main,
//                   })}
//                 >
//                   Delete
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>
//         </>
//       )}

//       {/* View Details Button */}
//       <>
//         <Box
//           sx={{
//             height: "20px",
//             width: "1px",
//             backgroundColor: "#E0E0E0",
//           }}
//         />
//         <Box
//           display="flex"
//           alignItems="center"
//           sx={{
//             backgroundColor: "#FAFAFA",
//             borderRadius: "6px",
//             border: "1px solid #E0E0E0",
//             padding: "4px 8px",
//             gap: 1,
//           }}
//         >
//           <Tooltip title="View Details">
//             <Box
//               display="flex"
//               alignItems="center"
//               sx={{
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   backgroundColor: "#E3F2FD",
//                 },
//               }}
//               onClick={onViewDetailsClick}
//             >
//               <VisibilityIcon fontSize="small" sx={{ color: "#1976d2" }} />
//               <Typography
//                 variant="body2"
//                 sx={{
//                   ml: 1,
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   color: "#1976d2",
//                 }}
//               >
//                 View Details
//               </Typography>
//             </Box>
//           </Tooltip>
//         </Box>
//       </>

//       {/* Assign Orders Button - Conditionally visible */}
// {params.row.clear_assigned_invoice_button_enabled === 1 && (
//         <>
//           <Box
//             sx={{
//               height: "20px",
//               width: "1px",
//               backgroundColor: "#E0E0E0",
//             }}
//           />
//           <Box
//             display="flex"
//             alignItems="center"
//             sx={{
//               backgroundColor: "#FAFAFA",
//               borderRadius: "6px",
//               border: "1px solid #E0E0E0",
//               padding: "4px 8px",
//               gap: 1,
//             }}
//           >
//             <Tooltip title="Clear Orders">
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 sx={{
//                   cursor: "pointer",
//                   padding: "4px 8px",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     backgroundColor: "#F0F0F0",
//                   },
//                 }}
//                 onClick={onClearOrdersClick}
//               >
//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <AssignedOrdersCell data={params.row.assigned_invoices} />
//                 </Box>
//                 <HourglassEmptyIcon
//                   fontSize="small"
//                   color="warning"
//                   sx={{ ml: 1 }}
//                 />
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     ml: 1,
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: "#ff9800",
//                   }}
//                 >
//                   {`Clear Invoice${
//                     params.row.assigned_invoices.length !== 1 ? "s" : ""
//                   }`}
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>
//         </>
//       )}

//       {/* Track Delivery Modal */}
//       <Dialog
//         open={openTrackDelivery}
//         onClose={handleCloseTrackDelivery}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
//           Delivery Route Tracker
//         </DialogTitle>
//         <DialogContent dividers sx={{ p: 0 }}>
//           <DeliveryTrackerAdmin />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseTrackDelivery}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delivery Report Modal */}
//       <Dialog
//         open={openDeliveryReport}
//         onClose={handleCloseDeliveryReport}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           style: {
//             height: "90vh",
//             maxHeight: "90vh",
//           },
//         }}
//       >
//         <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>Delivery Report</DialogTitle>
//         <DialogContent dividers sx={{ p: 0, height: "100%" }}>
//           <DeliveryReportModal driver={params.row} />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeliveryReport}>Close</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ActionsCell;


// ********************************************************************************************************************************

// import React, { useState } from "react";
// import {
//   Box,
//   Tooltip,
//   Typography,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
// import AssignmentIcon from "@mui/icons-material/Assignment";

// // Import the delivery tracker component
// import DeliveryTrackerAdmin from "./DeliveryTrackerAdmin";

// // Import the delivery report component
// import DeliveryReportModal from "./DeliveryReportModal";

// // Import the assigned orders cell component
// import AssignedOrdersCell from "./AssignedOrdersCell";

// const ActionsCell = ({
//   params,
//   handleEdit,
//   setOpenDeleteDriver,
//   setSelectedDriver,
//   setOpenViewDetails,
//   setSelectedDriverForView,
//   // Props for assign orders modal
//   setOpenAssignOrders,
//   setSelectedDriverForAssignOrders,
//   // Props for clear orders modal
//   setOpenClearOrders,
//   setSelectedDriverForClearOrders,
// }) => {
//   console.log("props test", params)
//   const [openTrackDelivery, setOpenTrackDelivery] = useState(false);
//   const [openDeliveryReport, setOpenDeliveryReport] = useState(false);

//   const onEditClick = () => {
//     handleEdit(params.row);
//   };

//   const onDeleteClick = () => {
//     setSelectedDriver(params.row);
//     setOpenDeleteDriver(true);
//   };

//   const onViewDetailsClick = () => {
//     setSelectedDriverForView(params.row);
//     setOpenViewDetails(true);
//   };

//   const onTrackDeliveryClick = () => {
//     setOpenTrackDelivery(true);
//   };

//   const onDeliveryReportClick = () => {
//     setOpenDeliveryReport(true);
//   };

//   const onAssignOrdersClick = () => {
//     setSelectedDriverForAssignOrders(params.row);
//     setOpenAssignOrders(true);
//   };

//   const onClearOrdersClick = () => {
//     setSelectedDriverForClearOrders(params.row);
//     setOpenClearOrders(true);
//   };

//   const handleCloseTrackDelivery = () => {
//     setOpenTrackDelivery(false);
//   };

//   const handleCloseDeliveryReport = () => {
//     setOpenDeliveryReport(false);
//   };

//   // Handler for clearing orders from inside the dialog
//   const handleClearOrdersFromDialog = (driverId, driverName) => {
//     const driver = {
//       id: driverId,
//       full_name: driverName,
//     };
//     setSelectedDriverForClearOrders(driver);
//     setOpenClearOrders(true);
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: 1,
//         height: "100%",
//         minHeight: "52px",
//       }}
//     >
//       {/* Edit Button */}
//       {params.row.allow_edit === 1 && (
//         <Box
//           display="flex"
//           alignItems="center"
//           sx={{
//             backgroundColor: "#FAFAFA",
//             borderRadius: "6px",
//             border: "1px solid #E0E0E0",
//             padding: "4px 0",
//             gap: 1,
//           }}
//         >
//           <Tooltip title="Edit">
//             <Box
//               display="flex"
//               alignItems="center"
//               sx={{
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   backgroundColor: "#F0F0F0",
//                 },
//               }}
//               onClick={onEditClick}
//             >
//               <EditIcon fontSize="small" sx={{ color: "#48505E" }} />
//               <Typography
//                 variant="body2"
//                 sx={{
//                   ml: 1,
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   color: "#1976D2",
//                 }}
//               >
//                 Edit
//               </Typography>
//             </Box>
//           </Tooltip>
//         </Box>
//       )}

//       {/* Delete Button - Only show if delete is enabled */}
//       {params.row.driver_deleted_button === 1 && (
//         <>
//           <Box
//             sx={{
//               height: "20px",
//               width: "1px",
//               backgroundColor: "#E0E0E0",
//             }}
//           />
//           <Box
//             display="flex"
//             alignItems="center"
//             sx={{
//               backgroundColor: "#FAFAFA",
//               borderRadius: "6px",
//               border: "1px solid #E0E0E0",
//               padding: "4px 8px",
//               gap: 1,
//             }}
//           >
//             <Tooltip title="Delete">
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 sx={{
//                   cursor: "pointer",
//                   padding: "4px 8px",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     backgroundColor: "#FFEBEE",
//                   },
//                 }}
//                 onClick={onDeleteClick}
//               >
//                 <DeleteForeverIcon fontSize="small" sx={{ color: "#d32f2f" }} />
//                 <Typography
//                   variant="body2"
//                   sx={(theme) => ({
//                     ml: 1,
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: theme.palette.error.main,
//                   })}
//                 >
//                   Delete
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>
//         </>
//       )}

//       {/* View Details Button */}
//       <>
//         <Box
//           sx={{
//             height: "20px",
//             width: "1px",
//             backgroundColor: "#E0E0E0",
//           }}
//         />
//         <Box
//           display="flex"
//           alignItems="center"
//           sx={{
//             backgroundColor: "#FAFAFA",
//             borderRadius: "6px",
//             border: "1px solid #E0E0E0",
//             padding: "4px 8px",
//             gap: 1,
//           }}
//         >
//           <Tooltip title="View Details">
//             <Box
//               display="flex"
//               alignItems="center"
//               sx={{
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   backgroundColor: "#E3F2FD",
//                 },
//               }}
//               onClick={onViewDetailsClick}
//             >
//               <VisibilityIcon fontSize="small" sx={{ color: "#1976d2" }} />
//               <Typography
//                 variant="body2"
//                 sx={{
//                   ml: 1,
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   color: "#1976d2",
//                 }}
//               >
//                 View Details
//               </Typography>
//             </Box>
//           </Tooltip>
//         </Box>
//       </>

//       {/* Clear Orders Button - Conditionally visible */}
//       {params.row.clear_assigned_invoice_button_enabled === 1 && (
//         <>
//           <Box
//             sx={{
//               height: "20px",
//               width: "1px",
//               backgroundColor: "#E0E0E0",
//             }}
//           />
//           <Box
//             display="flex"
//             alignItems="center"
//             sx={{
//               backgroundColor: "#FAFAFA",
//               borderRadius: "6px",
//               border: "1px solid #E0E0E0",
//               padding: "4px 8px",
//               gap: 1,
//             }}
//           >
//             <Tooltip title="Clear Orders">
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 sx={{
//                   cursor: "pointer",
//                   padding: "4px 8px",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     backgroundColor: "#F0F0F0",
//                   },
//                 }}
//                 onClick={onClearOrdersClick}
//               >
//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <AssignedOrdersCell 
//                     data={params.row.assigned_invoices}
//                     driverId={params.row.id}
//                     driverName={params.row.full_name}
//                     onClearOrders={handleClearOrdersFromDialog}
//                   />
//                 </Box>
//                 <HourglassEmptyIcon
//                   fontSize="small"
//                   color="warning"
//                   sx={{ ml: 1 }}
//                 />
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     ml: 1,
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: "#ff9800",
//                   }}
//                 >
//                   {`Clear Invoice${
//                     params.row.assigned_invoices.length !== 1 ? "s" : ""
//                   }`}
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>
//         </>
//       )}

//       {/* Track Delivery Modal */}
//       <Dialog
//         open={openTrackDelivery}
//         onClose={handleCloseTrackDelivery}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
//           Delivery Route Tracker
//         </DialogTitle>
//         <DialogContent dividers sx={{ p: 0 }}>
//           <DeliveryTrackerAdmin />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseTrackDelivery}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delivery Report Modal */}
//       <Dialog
//         open={openDeliveryReport}
//         onClose={handleCloseDeliveryReport}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           style: {
//             height: "90vh",
//             maxHeight: "90vh",
//           },
//         }}
//       >
//         <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>Delivery Report</DialogTitle>
//         <DialogContent dividers sx={{ p: 0, height: "100%" }}>
//           <DeliveryReportModal driver={params.row} />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeliveryReport}>Close</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ActionsCell;





// import React, { useState } from "react";
// import {
//   Box,
//   Tooltip,
//   Typography,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
// } from "@mui/material";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import EditIcon from "@mui/icons-material/Edit";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
// import AssignmentIcon from "@mui/icons-material/Assignment";

// // Import the delivery tracker component
// import DeliveryTrackerAdmin from "./DeliveryTrackerAdmin";

// // Import the delivery report component
// import DeliveryReportModal from "./DeliveryReportModal";

// // Import the assigned orders cell component
// import AssignedOrdersCell from "./AssignedOrdersCell";

// const ActionsCell = ({
//   params,
//   handleEdit,
//   setOpenDeleteDriver,
//   setSelectedDriver,
//   setOpenViewDetails,
//   setSelectedDriverForView,
//   setOpenAssignOrders,
//   setSelectedDriverForAssignOrders,
//   setOpenClearOrders,
//   setSelectedDriverForClearOrders,
//   onRefreshData,
//   allDrivers, // Add this
// }) => {
//   console.log("props test", params)
//   const [openTrackDelivery, setOpenTrackDelivery] = useState(false);
//   const [openDeliveryReport, setOpenDeliveryReport] = useState(false);

//   const onEditClick = () => {
//     handleEdit(params.row);
//   };

//   const onDeleteClick = () => {
//     setSelectedDriver(params.row);
//     setOpenDeleteDriver(true);
//   };

//   const onViewDetailsClick = () => {
//     setSelectedDriverForView(params.row);
//     setOpenViewDetails(true);
//   };

//   const onTrackDeliveryClick = () => {
//     setOpenTrackDelivery(true);
//   };

//   const onDeliveryReportClick = () => {
//     setOpenDeliveryReport(true);
//   };

//   const onAssignOrdersClick = () => {
//     setSelectedDriverForAssignOrders(params.row);
//     setOpenAssignOrders(true);
//   };

//   const onClearOrdersClick = () => {
//     setSelectedDriverForClearOrders(params.row);
//     setOpenClearOrders(true);
//   };

//   const handleCloseTrackDelivery = () => {
//     setOpenTrackDelivery(false);
//   };

//   const handleCloseDeliveryReport = () => {
//     setOpenDeliveryReport(false);
//   };

//   // Handler for clearing orders from inside the dialog
//   const handleClearOrdersFromDialog = (driverId, driverName) => {
//     const driver = {
//       id: driverId,
//       full_name: driverName,
//     };
//     setSelectedDriverForClearOrders(driver);
//     setOpenClearOrders(true);
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         gap: 1,
//         height: "100%",
//         minHeight: "52px",
//       }}
//     >
//       {/* Edit Button */}
//       {params.row.allow_edit === 1 && (
//         <Box
//           display="flex"
//           alignItems="center"
//           sx={{
//             backgroundColor: "#FAFAFA",
//             borderRadius: "6px",
//             border: "1px solid #E0E0E0",
//             padding: "4px 0",
//             gap: 1,
//           }}
//         >
//           <Tooltip title="Edit">
//             <Box
//               display="flex"
//               alignItems="center"
//               sx={{
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   backgroundColor: "#F0F0F0",
//                 },
//               }}
//               onClick={onEditClick}
//             >
//               <EditIcon fontSize="small" sx={{ color: "#48505E" }} />
//               <Typography
//                 variant="body2"
//                 sx={{
//                   ml: 1,
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   color: "#1976D2",
//                 }}
//               >
//                 Edit
//               </Typography>
//             </Box>
//           </Tooltip>
//         </Box>
//       )}

//       {/* Delete Button - Only show if delete is enabled */}
//       {params.row.driver_deleted_button === 1 && (
//         <>
//           <Box
//             sx={{
//               height: "20px",
//               width: "1px",
//               backgroundColor: "#E0E0E0",
//             }}
//           />
//           <Box
//             display="flex"
//             alignItems="center"
//             sx={{
//               backgroundColor: "#FAFAFA",
//               borderRadius: "6px",
//               border: "1px solid #E0E0E0",
//               padding: "4px 8px",
//               gap: 1,
//             }}
//           >
//             <Tooltip title="Delete">
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 sx={{
//                   cursor: "pointer",
//                   padding: "4px 8px",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     backgroundColor: "#FFEBEE",
//                   },
//                 }}
//                 onClick={onDeleteClick}
//               >
//                 <DeleteForeverIcon fontSize="small" sx={{ color: "#d32f2f" }} />
//                 <Typography
//                   variant="body2"
//                   sx={(theme) => ({
//                     ml: 1,
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: theme.palette.error.main,
//                   })}
//                 >
//                   Delete
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>
//         </>
//       )}

//       {/* View Details Button */}
//       <>
//         <Box
//           sx={{
//             height: "20px",
//             width: "1px",
//             backgroundColor: "#E0E0E0",
//           }}
//         />
//         <Box
//           display="flex"
//           alignItems="center"
//           sx={{
//             backgroundColor: "#FAFAFA",
//             borderRadius: "6px",
//             border: "1px solid #E0E0E0",
//             padding: "4px 8px",
//             gap: 1,
//           }}
//         >
//           <Tooltip title="View Details">
//             <Box
//               display="flex"
//               alignItems="center"
//               sx={{
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "4px",
//                 "&:hover": {
//                   backgroundColor: "#E3F2FD",
//                 },
//               }}
//               onClick={onViewDetailsClick}
//             >
//               <VisibilityIcon fontSize="small" sx={{ color: "#1976d2" }} />
//               <Typography
//                 variant="body2"
//                 sx={{
//                   ml: 1,
//                   fontSize: "13px",
//                   fontWeight: 500,
//                   color: "#1976d2",
//                 }}
//               >
//                 View Details
//               </Typography>
//             </Box>
//           </Tooltip>
//         </Box>
//       </>

//       {/* Clear Orders Button - Conditionally visible */}
//       {params.row.clear_assigned_invoice_button_enabled === 1 && (
//         <>
//           <Box
//             sx={{
//               height: "20px",
//               width: "1px",
//               backgroundColor: "#E0E0E0",
//             }}
//           />
//           <Box
//             display="flex"
//             alignItems="center"
//             sx={{
//               backgroundColor: "#FAFAFA",
//               borderRadius: "6px",
//               border: "1px solid #E0E0E0",
//               padding: "4px 8px",
//               gap: 1,
//             }}
//           >
//             <Tooltip title="Clear Orders">
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 sx={{
//                   cursor: "pointer",
//                   padding: "4px 8px",
//                   borderRadius: "4px",
//                   "&:hover": {
//                     backgroundColor: "#F0F0F0",
//                   },
//                 }}
//                 onClick={onClearOrdersClick}
//               >
//                 <Box
//                   display="flex"
//                   alignItems="center"
//                   onClick={(e) => e.stopPropagation()}
//                 >
//        <AssignedOrdersCell 
//     data={params.row.assigned_invoices}
//     driverId={params.row.id}
//     driverName={params.row.full_name}
//     onClearOrders={handleClearOrdersFromDialog}
//     onRefreshData={onRefreshData}
//     allDrivers={allDrivers} // Pass this
//   />
//                 </Box>
//                 <HourglassEmptyIcon
//                   fontSize="small"
//                   color="warning"
//                   sx={{ ml: 1 }}
//                 />
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     ml: 1,
//                     fontSize: "13px",
//                     fontWeight: 500,
//                     color: "#ff9800",
//                   }}
//                 >
//                   {`Clear Invoice${
//                     params.row.assigned_invoices.length !== 1 ? "s" : ""
//                   }`}
//                 </Typography>
//               </Box>
//             </Tooltip>
//           </Box>
//         </>
//       )}

//       {/* Track Delivery Modal */}
//       <Dialog
//         open={openTrackDelivery}
//         onClose={handleCloseTrackDelivery}
//         maxWidth="lg"
//         fullWidth
//       >
//         <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>
//           Delivery Route Tracker
//         </DialogTitle>
//         <DialogContent dividers sx={{ p: 0 }}>
//           <DeliveryTrackerAdmin />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseTrackDelivery}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delivery Report Modal */}
//       <Dialog
//         open={openDeliveryReport}
//         onClose={handleCloseDeliveryReport}
//         maxWidth="lg"
//         fullWidth
//         PaperProps={{
//           style: {
//             height: "90vh",
//             maxHeight: "90vh",
//           },
//         }}
//       >
//         <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>Delivery Report</DialogTitle>
//         <DialogContent dividers sx={{ p: 0, height: "100%" }}>
//           <DeliveryReportModal driver={params.row} />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeliveryReport}>Close</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ActionsCell;

import React, { useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import AssignmentIcon from "@mui/icons-material/Assignment";
import DeliveryTrackerAdmin from "./DeliveryTrackerAdmin";
import DeliveryReportModal from "./DeliveryReportModal";
import AssignedOrdersDialog from "./AssignedOrdersDialog";

const ActionsCell = ({
  params,
  handleEdit,
  setOpenDeleteDriver,
  setSelectedDriver,
  setOpenViewDetails,
  setSelectedDriverForView,
  setOpenAssignOrders,
  setSelectedDriverForAssignOrders,
  setOpenClearOrders,
  setSelectedDriverForClearOrders,
  onRefreshData,
  allDrivers,
}) => {
  const [openTrackDelivery, setOpenTrackDelivery] = useState(false);
  const [openDeliveryReport, setOpenDeliveryReport] = useState(false);
  const [openAssignedOrders, setOpenAssignedOrders] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const openMenu = (event) => setMenuAnchorEl(event.currentTarget);
  const closeMenu = () => setMenuAnchorEl(null);

  const onEditClick = () => {
    handleEdit(params.row);
    closeMenu();
  };
  const onDeleteClick = () => {
    setSelectedDriver(params.row);
    setOpenDeleteDriver(true);
    closeMenu();
  };
  const onViewDetailsClick = () => {
    setSelectedDriverForView(params.row);
    setOpenViewDetails(true);
    closeMenu();
  };
  const onAssignedInvoicesClick = () => {
    setOpenAssignedOrders(true);
    closeMenu();
  };
  const handleCloseTrackDelivery = () => setOpenTrackDelivery(false);
  const handleCloseDeliveryReport = () => setOpenDeliveryReport(false);

  const handleClearOrdersFromDialog = (driverId, driverName) => {
    setSelectedDriverForClearOrders({ id: driverId, full_name: driverName });
    setOpenClearOrders(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "100%",
        minHeight: "52px",
      }}
    >
      <IconButton size="small" onClick={openMenu}>
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={closeMenu}>
        {params.row.allow_edit === 1 && (
          <MenuItem onClick={onEditClick}>
            <ListItemIcon>
              <EditIcon fontSize="small" sx={{ color: "#48505E" }} />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
          </MenuItem>
        )}

        {params.row.driver_deleted_button === 1 && (
          <MenuItem onClick={onDeleteClick}>
            <ListItemIcon>
              <DeleteForeverIcon fontSize="small" sx={{ color: "#d32f2f" }} />
            </ListItemIcon>
            <ListItemText sx={{ color: "error.main" }}>Delete</ListItemText>
          </MenuItem>
        )}

        <MenuItem onClick={onViewDetailsClick}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" sx={{ color: "#1976d2" }} />
          </ListItemIcon>
          <ListItemText>View Details</ListItemText>
        </MenuItem>

        {params.row.assigned_invoice_count > 0 && (
          <MenuItem onClick={onAssignedInvoicesClick}>
            <ListItemIcon>
              <AssignmentIcon fontSize="small" sx={{ color: "#1976d2" }} />
            </ListItemIcon>
            <ListItemText>{`Assigned Invoices (${params.row.assigned_invoice_count})`}</ListItemText>
          </MenuItem>
        )}
      </Menu>

      {openAssignedOrders && (
        <AssignedOrdersDialog
          open={openAssignedOrders}
          onClose={() => setOpenAssignedOrders(false)}
          orders={params.row.assigned_invoices}
          driverId={params.row.id}
          driverName={params.row.full_name}
          currentInvoicesState={params.row.current_invoices_state}
          currentInvoicesStateColor={params.row.current_invoices_state_color}
          onClearOrders={handleClearOrdersFromDialog}
          onRefreshData={onRefreshData}
          allDrivers={allDrivers}
        />
      )}

      {/* Track Delivery Modal */}
      <Dialog
        open={openTrackDelivery}
        onClose={handleCloseTrackDelivery}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>Delivery Route Tracker</DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <DeliveryTrackerAdmin />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseTrackDelivery}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Delivery Report Modal */}
      <Dialog
        open={openDeliveryReport}
        onClose={handleCloseDeliveryReport}
        maxWidth="lg"
        fullWidth
        PaperProps={{ style: { height: "90vh", maxHeight: "90vh" } }}
      >
        <DialogTitle sx={{ bgcolor: "#f5f5f5" }}>Delivery Report</DialogTitle>
        <DialogContent dividers sx={{ p: 0, height: "100%" }}>
          <DeliveryReportModal driver={params.row} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeliveryReport}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ActionsCell;